import el from "@cypherpotato/el";
import { cond } from "../util";

export function TabControl(tabPages, options) {
    const typeName = cond(
        [options?.type == "vertical", "tab-control-vertical"],
        [options?.type == "fixed", "tab-control-fixed"],
        [true, "tab-control-horizontal"]
    );
    var tabControl = el(".tab-control",
        {
            classList: [
                typeName,
                options?.tabstripExtraPadded && "tab-control-tabstrip-extra-padded"
            ]
        },
        {
            $properties: {
                currentTab: {
                    get() {
                        return this.querySelector(":scope > .tab-control-tab-strip > .tab-item-toggle.tab-control-tab-selected")?.dataset.tabName;
                    },
                    set(value) {
                        this.querySelectorAll(":scope > .tab-control-tab-strip > .tab-item-toggle, :scope > .tab-control-body > .tab-control-tab-contents").forEach(tab => {
                            const selected = tab.dataset.tabName === value;
                            tab.classList.toggle("tab-control-tab-selected", selected);
                            if (tab.classList.contains("tab-item-toggle")) {
                                tab.setAttribute("aria-selected", selected.toString());
                            }
                        });
                    }
                }
            }
        },
        el(".tab-control-tab-strip",
            { role: "tablist" },
            ...tabPages.filter(n => n).map(tab =>
                el("button.tab-item-toggle[type=button]",
                    {
                        dataTabName: tab.title,
                        role: "tab",
                        ariaLabel: tab.title,
                        ariaSelected: "false",
                        onClick() {
                            tabControl.currentTab = tab.title;
                        }
                    },
                    tab.icon && el(".tab-control-tab-icon", tab.icon),
                    options?.type != "vertical" && el(".tab-control-tab-title", tab.title),
                )
            )
        ),
        el(".tab-control-body[height-target]",
            ...tabPages.map(tab =>
                el(".tab-control-tab-contents",
                    tab.contents,
                    {
                        dataTabName: tab.title,
                        role: "tabpanel"
                    }
                )
            )
        )
    );

    tabControl.currentTab = tabPages[0].title;

    return tabControl;
}
